import { useEffect, useState } from 'react';
import { Form, Checkbox, Typography, Button, Spin } from 'antd';

import { errorCatch, GET } from 'fennec-ui'

import { Agreement } from '../../../common/Agreement';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

export default function Vozvrat(props) {
    const { auth, form, zakaz } = props;
    const [loading, setLoading] = useState(false);
    const [summa, setSumma] = useState();

    useEffect(() => {
        form.resetFields();

        if (zakaz?.ID) {
            GET(auth, `/api/zakaz/summa-vozvrata/${zakaz?.ID}`,
                ({ data }) => {
                    setSumma(data);
                    setLoading(false);
                }, (err) => errorCatch(err, () => setLoading(false)));
        }
    }, []);

    return (
        <>
            <Spin spinning={loading}>
                {(!!summa) && <div>Сумма в размере {Number(summa?.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. будет возвращена клиенту.</div>}
                <Form
                    form={form}
                    onFinish={props.submit}
                    labelAlign={"left"}
                    layout={"vertical"}
                >
                    <Form.Item
                        name="polniiVozvrat"
                        valuePropName="checked"
                    >
                        <Checkbox>
                            Вернуть всю сумму {Number(zakaz?.obshchayaSumma?.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
                        </Checkbox>
                    </Form.Item>
                </Form>
            </Spin>
        </>
    );
}
